import { z } from 'zod';

// const appointmentFeeSchema = z.object({
//    isFreeAppointment: z.boolean().optional(),
//    min_appointment_fee: z.number().min(1, 'Minimum appointment fee is required'),
//    max_appointment_fee: z.number().min(1, 'Maximum appointment fee is required'),
// });

// export type TAppointmentFee = z.infer<typeof appointmentFeeSchema>;
// export { appointmentFeeSchema };

const appointmentFeeSchema = z
   .object({
      isFreeAppointment: z.boolean().optional(),
      min_appointment_fee: z.number().optional(),
      max_appointment_fee: z.number().optional(),
   })
   .superRefine((data, ctx) => {
      console.log(data.isFreeAppointment, '--data.isFreeAppointment');

      if (!data.isFreeAppointment) {
         if (data.min_appointment_fee == null) {
            ctx.addIssue({
               path: ['min_appointment_fee'],
               code: z.ZodIssueCode.custom,
               message: 'Minimum appointment fee is required',
            });
         } else if (data.min_appointment_fee < 0) {
            ctx.addIssue({
               path: ['min_appointment_fee'],
               code: z.ZodIssueCode.custom,
               message: 'Minimum appointment fee cannot be negative',
            });
         }

         if (data.max_appointment_fee == null) {
            ctx.addIssue({
               path: ['max_appointment_fee'],
               code: z.ZodIssueCode.custom,
               message: 'Maximum appointment fee is required',
            });
         } else if (data.max_appointment_fee < 0) {
            ctx.addIssue({
               path: ['max_appointment_fee'],
               code: z.ZodIssueCode.custom,
               message: 'Maximum appointment fee cannot be negative',
            });
         }
      }
   });

export type TAppointmentFee = z.infer<typeof appointmentFeeSchema>;
export { appointmentFeeSchema };
